<template>
  <div class="check-api main-second-bg">
    <p class="check-api-header b-1-cl a-3-bd">{{ $t("personal.checkApi.title") }}</p>
    <div class="center-inputs" v-show="divShow === 1">
      <c-inputLine
        v-show="smsCode"
        maxLength="6"
        name="phoneCode"
        inputType="text"
        :promptText="promptText1"
        :errorHave="true"
        :errorText="errorText1"
        :errorFlag="checkErrorFlag1"
        marginTop="0px"
        :value="checkValue1"
        @onchanges="inputChanges"
        newStyleFormat
        fill
      >
        <!-- 获取验证码 -->
        <c-getCode
          name="phone"
          :autoStart="false"
          @click="getCodeClick"
          buttonName="loginGetcodeBtn"
        />
      </c-inputLine>
      <c-inputLine
        v-show="googleCode"
        maxLength="6"
        name="googleCode"
        inputType="text"
        :promptText="promptText2"
        :errorHave="true"
        :errorText="errorText2"
        :errorFlag="checkErrorFlag2"
        marginTop="0px"
        :value="checkValue2"
        @onchanges="inputChanges"
        newStyleFormat
        fill
      >
      </c-inputLine>
      <c-button
        type="solid"
        :loading="loading"
        :big="true"
        className=""
        paddingW="0px"
        :disabled="disabled"
        marginTop="18px"
        height="40px"
        width="100%"
        @click="btnLink"
        >{{ $t("personal.tool.confirm") }}</c-button
      >
    </div>
    <div class="center-code" v-show="divShow === 2">
      <img :src="qrCode" />
      <div class="a-4-bg">
        <p class="b-2-cl">SecretKey</p>
        <p class="b-1-cl">
          {{ secretKey }}
          <span
            @click="copyClick('secretKey')"
            @mouseenter="handMouseenter"
            @mouseleave="handMouseleave"
          >
          <svg-icon class="icon icon-14" icon-class="resetCopyIcon"></svg-icon>
          </span>
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'checkApi',
  watch: {
    sendSmsCode(sendSmsCode) {
      if (sendSmsCode !== null) {
        if (sendSmsCode.text === 'success') {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'success' });
          this.$store.dispatch('resetType');
        } else {
          this.$bus.$emit('tip', { text: sendSmsCode.msg, type: 'error' });
          this.$store.dispatch('resetType');
        }
      }
    },
    openApiOne(openApiOne) {
      if (openApiOne !== null) {
        this.loading = false;
        if (openApiOne.text === 'success') {
          this.$bus.$emit('tip', { text: openApiOne.msg, type: 'success' });
          this.$store.dispatch('resetType');
          this.secretKey = openApiOne.data.secretKey;
          this.qrCode = openApiOne.data.qrCode;
          this.divShow = 2;
        } else {
          this.$bus.$emit('tip', { text: openApiOne.msg, type: 'error' });
          this.$store.dispatch('resetType');
          if (openApiOne.code !== '10009') {
            this.$bus.$emit('getCode-clear', 'phone');
          }
        }
      }
    },
  },
  data() {
    return {
      svgShow: true,
      // input'
      loading: false,
      divShow: 1,
      promptText1: this.$t('personal.label.smsCodeText'),
      errorText1: this.$t('personal.prompt.errorCode'),
      checkErrorFlag1: false,
      checkValue1: '',
      promptText2: this.$t('personal.label.googleCodeText'),
      errorText2: this.$t('personal.prompt.errorCode'),
      checkErrorFlag2: false,
      checkValue2: '',
      disabled: true,
      secretKey: '',
      qrCode: '',
    };
  },
  computed: {
    sendSmsCode() {
      return this.$store.state.personal.sendSmsCode;
    },
    openApiOne() {
      return this.$store.state.personal.openApiOne;
    },
    googleCode() {
      const { userInfo } = this.$store.state.baseData;
      return userInfo && !!Number(userInfo.googleStatus);
    },
    smsCode() {
      const { userInfo } = this.$store.state.baseData;
      return userInfo && !!Number(userInfo.isOpenMobileCheck);
    },
  },
  methods: {
    handMouseenter() {
      this.svgShow = false;
    },
    handMouseleave() {
      this.svgShow = true;
    },
    codeFlag(val) {
      return this.$store.state.regExp.verification.test(val);
    },
    getCodeClick() {
      this.$bus.$emit('getCode-start', 'phone');
      const info = { operationType: 16 };
      this.$store.dispatch('sendSmsCode', info);
    },
    inputChanges(val, name) {
      switch (name) {
        case 'phoneCode':
          this.checkValue1 = val;
          if (this.codeFlag(val)) {
            this.checkErrorFlag1 = false;
          } else {
            this.checkErrorFlag1 = true;
          }
          break;
        default:
          this.checkValue2 = val;
          if (this.codeFlag(val)) {
            this.checkErrorFlag2 = false;
          } else {
            this.checkErrorFlag2 = true;
          }
      }

      if (!this.checkErrorFlag1 && !this.checkErrorFlag2) {
        if (this.smsCode) {
          this.disabled = !this.checkValue1;
        }
        if (this.googleCode) {
          this.disabled = !this.checkValue2;
        }
      } else {
        this.disabled = true;
      }
    },
    btnLink() {
      this.loading = true;
      const token = this.$store.state.personal.apiToken;
      const info = {
        smsValidCode: this.checkValue1,
        googleCode: this.checkValue2,
        token,
      };
      this.$store.dispatch('openApiOne', info);
    },
    copyClick(name) {
      if (name === 'secretKey') {
        this.copy(this.secretKey);
      }
    },
    copy(str) {
      // this.$bus.$emit('tip', { text: this.$t('personal.prompt.copySucces'), type: 'success' });
      function save(e) {
        e.clipboardData.setData('text/plain', str); // 下面会说到clipboardData对象
        e.preventDefault(); // 阻止默认行为
      }
      document.addEventListener('copy', save);
      document.execCommand('copy'); // 使文档处于可编辑状态，否则无效
      document.removeEventListener('copy', save);
    },
  },
};
</script>

<style lang="scss" scoped>
.check-api {
  width: 100%;
  min-height: 800px;

  .check-api-header {
    font-size: 14px;
    padding: 18px 0 18px 20px;
    border-bottom-width: 1px;
    border-bottom-style: solid;
    box-sizing: border-box;
  }
  .center-inputs {
    width: 447px;
    margin: 60px auto;
  }
  .center-code {
    width: 447px;
    margin: 60px auto;
    img {
      width: 100px;
      height: 100px;
      margin-bottom: 30px;
    }
    div {
      height: 70px;
      p:nth-of-type(1) {
        font-size: 12px;
        padding: 12px 0 5px 0px;
      }
      p:nth-of-type(2) {
        font-size: 14px;
        svg {
          margin-left: 6px;
          cursor: pointer;
        }
      }
    }
  }
}
</style>
